export default {
    intro: 'Look at clues like consonant hints, definitions, and example sentences<br />to figure out the word!',
    word: 'Word',
    meaning: 'Meaning',
    example: 'Example',
    resources: 'Resources',
    teacherFooter: {
        left: 'Please select a word from the questions on the left.',
    },
    table: {
        question: 'Question',
        emptyMessage: 'No content available.',
    },
};
